import { basicAccountInfo } from "api/basic_account_info";
import { generic_get_api, generic_put_api } from "api/generic_api";
import { Component, useState } from "react";
import { Button, Form, Modal } from 'react-bootstrap';
import { CODE_SECTIONS } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import { SfUseDistrict, Topics } from 'utils/sf_code_constants';
import { truncateText } from "utils/helpers";


class CodeSections extends Component {

    constructor(props) {
        let section_id = null;

        let urlParams = new URLSearchParams(window.location.search);
        section_id = urlParams.get('section_id');


        super(props);

        this.state = {
            section_id: section_id,
            current_topic: null,
            parts: [],
            session_ok: false,
            working: false,
            articles: [],
            sections_for_topic: [],
        };
        this.fetchCodeParts = this.fetchCodeParts.bind(this);
        this.fetchArticles = this.fetchArticles.bind(this);
        this.navigateToSection = this.navigateToSection.bind(this);
        this.fetchSectionsForTopic = this.fetchSectionsForTopic.bind(this);
        this.onTopicClick = this.onTopicClick.bind(this);
    }

    fetchCodeParts() {
        this.setState({working: true });
        let request = {
            section: this.state.section_id,
            request_type: 'section',
        }

        generic_get_api(CODE_SECTIONS, request)
        .then(
            data => { 
                this.setState({
                    parts: data.section_parts,
                    section_title: data.section_title,
                    display_section_id: data.section_id,
                    external_url: data.external_url,
                    definitions: data.definitions,
                    topics: data.topics,
                    outgoing_links: data.outgoing_links,
                    incoming_links: data.incoming_links,
                    long_summary_list: data.long_summary_list,
                    working: false,
                })
            }
        )
        .catch(error => {
        });
    }

    fetchArticles() {

        let request = {
            request_type: 'articles_list',
        }

        generic_get_api(CODE_SECTIONS, request)
        .then(
            data => { 
                this.setState({
                    articles: data.articles,
                })
            }
        )
        .catch(error => {
        });
    }

    fetchSectionsForTopic() {

        let request = {
            request_type: 'topic',
            topic: this.state.current_topic,
        }

        generic_get_api(CODE_SECTIONS, request)
        .then(
            data => { 
                this.setState({
                    sections_for_topic: data.sections,
                })
            }
        )
        .catch(error => {
        });
    }

    navigateToSection(section_id) {
        window.scrollTo(0, -100);

        this.setState(
            {
                section_id: section_id,
                current_topic: null,
            },
            this.fetchCodeParts
        )
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'code_parts'});
        basicAccountInfo()
        .then(
            data => {
                this.setState({session_ok: true });
                this.fetchArticles();

                if (this.state.section_id) {
                    this.fetchCodeParts();
                }
            }
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });
    }

    onTopicClick(topic) {
        this.setState({
            current_topic: topic,
            section_id: null,
        }, this.fetchSectionsForTopic)
    }

    render() {
        const {parts, working, definitions, articles, display_section_id, section_title, external_url, topics, 
            outgoing_links, incoming_links, long_summary_list, section_id, current_topic, sections_for_topic} = this.state;
        

        const getMargin = (part) => {

            if(part.level === 1){
                return "row margin_subsection_1";
            }
            else if(part.level === 2){
                return "row margin_subsection_2";
            }
            else if(part.level === 3){
                return "row margin_subsection_3";
            }
            else if (part.level === 4) {
                return "row margin_subsection_4";
            }
            else if (part.level === 5) {
                return "row margin_subsection_5";
            }
            else {
                return "row";
            }
        }

        const getTableRowStyling = (row) => {
            if (row.is_header) {
                return "row fw-semibold bg-light bottom_border p-1";
            }
            else {
                return "row bottom_border p-1";
            }
        }

        return(
            <div class="container-fluid codeSections ps-4">
                {
                    working && 
                    <div class="container mt-5 text-center">
                        <span class="spinner-border" aria-hidden="true"></span>
                    </div>
                }
                
                <div class="row">
                    <div class="col-3 sectionListPanel mt-3 border-end">
                        <div class="row mb-1"><div class='col fw-semibold fw-5'>SF Planning Code</div></div>
                        <div class="row mb-1"><div class='col'><hr></hr></div></div>
                        {
                            articles.map(article => {
                                return <ArticleRow 
                                            article={article} 
                                            navigateToSection={this.navigateToSection}
                                        />
                            })
                        }
                    </div>
                    {
                        section_id && 
                        <>
                            <div class="col-6">
                                {
                                    display_section_id && section_title &&
                                    <div class="row mt-3">
                                        <div class="row mt-2">
                                            <div class="col fs-5 fw-bold">SEC. {display_section_id} {section_title}</div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col" style={{display: "flex", flexWrap: "wrap", rowGap: "5px"}}>
                                                { topics && topics.map((result_topic) => {
                                                    return <><input type="submit" value={result_topic} className="resultTopicLabel" onClick={() => this.onTopicClick(result_topic)}/>&nbsp;</>
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                }
                                
                                { parts.map((part, index) => {
                                    if (part.type === 'section' && part.order !== 0) {
                                        return <div class="row mt-1">
                                                    <div class="row mt-2">
                                                        <div class="col">
                                                            <div class={getMargin(part)}>
                                                                {
                                                                    part.level === 0 ? 
                                                                    <>
                                                                        <div class="col">{part.text}</div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        { part.subsection ?
                                                                            <>
                                                                                {part.level < 4?
                                                                                    <div class="col-1 pe-0 ps-0 subsection">({part.subsection})</div> 
                                                                                    :
                                                                                    <div class="col-1 pe-0 ps-0 subsection">{part.subsection}.</div>
                                                                                }
                                                                            </>
                                                                            
                                                                            :
                                                                            <div class="col-1 pe-0 ps-0 subsection">&nbsp;&nbsp;&nbsp;</div>
                                                                        }
                                                                        
                                                                        <div class="col">{part.text}</div>
                                                                    </>
                                                                
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>  
                                    }
                                    if (part.type === 'table') {
                                        return <div class="container mt-5 sectionTable">
                                                    {
                                                        (part.table_number || part.table_title) &&
                                                        
                                                        <div class="row mt-2 mb-3 fw-bold text-center">
                                                            <>{part.table_number && <div class="me-2">Table {part.table_number}</div>}</>
                                                            <>{part.table_title && <div class="col">{part.table_title}</div>}</>
                                                        </div>
                                                        
                                                    }
                                                    <div class="container border rounded">
                                                        {
                                                            part.rows.map(row=>{
                                                                return  <div class={getTableRowStyling(row)}>
                                                                            {
                                                                                row.columns.map(col => {
                                                                                    if (col) {
                                                                                        return <div class="col text-center">{col}</div>
                                                                                    }
                                                                                    
                                                                                })
                                                                            }
                                                                        </div>
                                                            })
                                                        }
                                                    </div>
                                                    {
                                                        part.foot_notes && part.foot_notes.length > 0 && 
                                                        <div class="container mt-2">
                                                        {
                                                            part.foot_notes.map(foot_note => {
                                                                return  <div class="row">
                                                                            <div class="col"><i class="fa-regular fa-note-sticky fa-sm"></i>&nbsp;<small>{foot_note}</small></div>
                                                                        </div>
                                                            })
                                                        }
                                                        </div>
                                                    }
                                                    
                                                </div>  
                                    }
                                    if (part.type === 'image') {
                                        return <div class="container mt-3">
                                                    <div class="row mt-2 mb-3 text-center">
                                                        <div class="col"><img src={part.url}/></div>
                                                    </div>
                                                </div>  
                                    }
                                })}
                            </div>
                            <div class="col-3">
                                <SideBar 
                                    definitions={definitions}
                                    outgoing_links={outgoing_links}
                                    incoming_links={incoming_links}
                                    long_summary_list={long_summary_list}
                                    external_url={external_url}
                                />
                            </div>
                        </>
                    }
                    {
                        current_topic &&
                        <div class="container col-9">
                            <div class="row mb-3"><div class="col fs-5 text-secondary">{current_topic}</div></div>
                            {
                                sections_for_topic && sections_for_topic.map(section => {
                                    return <div class="container mb-4">
                                                <div class="row"><div class="col fw-bold text-primary">
                                                    <a role="button" href={`/code/code_sections?section_id=${section.section_id}`} target="_blank"
                                                                        className="text-decoration-none fw-semibold text-primary">SEC. {section.section_id}&nbsp;
                                                                        <i class="fa-solid fa-arrow-up-right-from-square fa-xs"></i></a>
                                                    </div></div>
                                                <div class="row"><div class="col fw-bold">{section.title}</div></div>
                                                <div class="row mt-1"><div class="col fst-italic">{truncateText(section.summary, 150, true)}</div></div>
                                                <div class="row mt-2">
                                                    <div class="col" style={{display: "flex", flexWrap: "wrap", rowGap: "5px"}}>
                                                        { section.topics.map((topic) => {
                                                            return <><input type="submit" value={topic} className="resultTopicLabel"/>&nbsp;</>
                                                        })}
                                                </div></div>
                                            </div>
                                })
                            }
                            
                        </div>
                        
                    }
                    
                </div>
                
              
            </div>
        )
    }
}

function ArticleRow(props) {
    const {article, navigateToSection} = props;
    const [expanded, setExpanded] = useState(false);

    return (<div class="row mb-4">
                <div class="col-auto pe-0" role="button" onClick={() => setExpanded(!expanded)}>
                    {expanded ? <i class="fa-solid fa-chevron-down fa-lg" style={{"color": "#6c6b7d"}}></i>: <i class="fa-solid fa-lg fa-chevron-right" style={{"color": "#6c6b7d"}}></i>}
                </div>
                <div class="col">
                    <div class="row"><div class="col fw-semibold">Article {article.article_number}</div></div>
                    <div class="row"><div class="col articleName text-secondary">{article.title}</div></div>
                    {
                        expanded &&
                        <div class="row">
                            <div class="col border-start ms-3">
                                {
                                    article.children.map(child => {
                                        return <div class="row mt-3" role="button" onClick={() => navigateToSection(child.section_id)}>
                                                    <div class="row"><div class="col">§ {child.section_id}</div></div>
                                                    <div class="row"><div class="col text-secondary">{child.title}</div></div>
                                                </div>
                                    })
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
    );
}

function SideBar(props) {

    const {definitions, long_summary_list, outgoing_links, incoming_links, external_url} = props;

    return(
        <div class="container mt-3 border rounded grayBackground p-3">
            <div class="row mt-1 ms-2 me-2 p-3 border rounded whiteBackground">
                <div class="col fw-bold">
                     <i class="fa-solid fa-link"></i>&nbsp;&nbsp;
                     <a target="_blank" href={external_url} className="text-decoration-none text-black">External link&nbsp;&nbsp;
                    <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                </div>
            </div>
            <SummaryComponent long_summary_list={long_summary_list} />
            <DefinitionsComponent 
                definitions = {definitions}
            />
            <ReferencesComponent links={outgoing_links} title="References"/>
            <ReferencesComponent links={incoming_links} title="Referenced in"/>
        </div>
    )
}

function SummaryComponent(props) {
    const {long_summary_list} = props;
    const [expanded, setExpanded] = useState(false);
    const [show_summary_modal, setShowSummaryModal] = useState(false);

    const text_excerpt = (summary_list) => {
        let all_text = "";

        summary_list.forEach((item) => {
            all_text += " " + item;
        });

        return truncateText(all_text, 400, true);
    }

    if(!long_summary_list || long_summary_list.length <= 0) {
        return null;
    }

    return( <div class="row mt-4 ms-2 me-2 p-3 border rounded whiteBackground">
            {
                long_summary_list && long_summary_list.length > 0 &&
                <>
                    <div class="row mb-1" onClick={() => setExpanded(!expanded)} role="button">
                        <div class="col fw-bold">
                            {
                                expanded ? <i class="fa-solid fa-angle-down"></i> : <i class="fa-solid fa-angle-right"></i>
                            }
                            &nbsp;&nbsp;<i class="fa-solid fa-robot"></i>&nbsp;&nbsp;Summary
                        </div>
                    </div>
                    {
                        expanded && <div class="container mt-1">
                                        <div class="row mt-2"><div class="col text-secondary">{text_excerpt(long_summary_list)}</div></div>
                                        <div class="row mt-2" role="button" onClick={() => {setShowSummaryModal(true)}}>
                                            <div class="col"><i class="fa-solid fa-up-right-and-down-left-from-center"></i>&nbsp; Expand</div>
                                        </div>
                                    </div>
                        
                    }
                    <SummaryModal
                        show_summary_modal={show_summary_modal}
                        setShowSummaryModal={setShowSummaryModal}
                        long_summary_list={long_summary_list}
                    />
                </>
            }
            </div>
    )
}

function SummaryModal(props) {

    const { show_summary_modal, setShowSummaryModal, long_summary_list } = props;

    if (! long_summary_list || long_summary_list.length <= 0) {
        return <></>
    }

    return (
        <Modal
            show={show_summary_modal}
            onHide={() => setShowSummaryModal(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title><i class="fa-solid fa-robot"></i>&nbsp;Generated Summary</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div class="container summaryModal">
                   {
                        long_summary_list.map(part => {
                            return  <p>{part}</p>
                        })
                   }
                </div>
            </Modal.Body>
        </Modal>
    )
}



function DefinitionsComponent(props) {
    const {definitions} = props;
    const [expanded, setExpanded] = useState(false);
    const [show_definition_modal, setShowDefinitionModal] = useState(false);
    const [selected_definition, setSelectedDefinition] = useState(null);

    const text_excerpt = (definition) => {
        let all_text = "";

        definition.text_parts.forEach((item) => {
            all_text += " " + item.text;
        });

        return truncateText(all_text, 100, true);
    }

    if (!definitions || definitions.length <= 0){
        return null;
    }

    return( <div class="row mt-4 ms-2 me-2 p-3 border rounded whiteBackground">
            {
                definitions && definitions.length > 0 &&
                <>
                    <div class="row mb-1" onClick={() => setExpanded(!expanded)} role="button">
                        <div class="col fw-bold">
                            {
                                expanded ? <i class="fa-solid fa-angle-down"></i> : <i class="fa-solid fa-angle-right"></i>
                            }
                            &nbsp;&nbsp;<i class="fa-solid fa-spell-check"></i>&nbsp;&nbsp;Definitions
                        </div>
                    </div>
                    {
                        expanded && definitions.map(definition => {
                            return  <div class="container mt-4">
                                        <div class="row"><div class="col fw-semibold text-primary">{definition.term}</div></div>
                                        <div class="row mt-2"><div class="col text-secondary">{text_excerpt(definition)}</div></div>
                                        <div class="row mt-2" role="button" onClick={() => {setSelectedDefinition(definition); setShowDefinitionModal(true)}}>
                                            <div class="col"><i class="fa-solid fa-up-right-and-down-left-from-center"></i>&nbsp; Expand</div>
                                        </div>
                                    </div>
                        })
                    }
                    <DefinitionModal
                        show_definition_modal={show_definition_modal}
                        setShowDefinitionModal={setShowDefinitionModal}
                        definition={selected_definition}
                    />
                </>
            }
            </div>
    )
}

function DefinitionModal(props) {

    const { show_definition_modal, setShowDefinitionModal, definition } = props;

    const getMargin = (part) => {

        if(part.level === 1){
            return "row mt-1 margin_subsection_1";
        }
        else if(part.level === 2){
            return "row mt-1 margin_subsection_2";
        }
        else if(part.level === 3){
            return "row mt-1 margin_subsection_3";
        }
        else if (part.level === 4) {
            return "row mt-1 margin_subsection_4";
        }
        else if (part.level === 5) {
            return "row mt-1 margin_subsection_5";
        }
        else {
            return "row";
        }
    }

    if (! definition) {
        return <></>
    }

    return (
        <Modal
            show={show_definition_modal}
            onHide={() => setShowDefinitionModal(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>{definition.term}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div class="container definitionDetailModal">
                   {
                        definition.text_parts.map(part => {
                            return  <div class={getMargin(part)}>
                                        {
                                            part.level === 0 ? 
                                                <div class="col">{part.text}</div>
                                            :
                                            <>
                                                { part.subsection ?
                                                    <>
                                                        {part.level < 4?
                                                            <div class="col-1 pe-0 ps-0 subsection">({part.subsection})</div> 
                                                            :
                                                            <div class="col-1 pe-0 ps-0 subsection">{part.subsection}.</div>
                                                        }
                                                    </>
                                                    
                                                    :
                                                    <div class="col-1 pe-0 ps-0 subsection">&nbsp;&nbsp;&nbsp;</div>
                                                }
                                                
                                                <div class="col">{part.text}</div>
                                            </>

                                        }
                                    </div>
                        })
                   }
                </div>
            </Modal.Body>
        </Modal>
    )
}

function ReferencesComponent(props) {
    const {links, title} = props;
    const [expanded, setExpanded] = useState(false);

    if (!links || links.length <= 0) {
        return null;
    }

    return (<div class="row mt-4 ms-2 me-2 p-3 border rounded whiteBackground">
                {
                    links && links.length > 0 &&
                    <>
                        <div class={`row ${expanded ? "mb-3" : ""}`} onClick={() => setExpanded(!expanded)} role="button">
                            <div class="col fw-semibold">
                                {
                                    expanded ? <i class="fa-solid fa-angle-down"></i> : <i class="fa-solid fa-angle-right"></i>
                                }
                                &nbsp;&nbsp;<i class="fa-solid fa-link"></i>&nbsp;&nbsp;{title}
                            </div>
                        </div>
                        {
                            expanded && links.map(link => {
                                return  <div class="container mb-4">
                                            <div class="row"><div class="col">
                                                <a role="button" href={`/code/code_sections?section_id=${link.section_id}`} target="_blank"
                                                        className="text-decoration-none fw-semibold text-primary">SEC. {link.section_id}&nbsp;
                                                        <i class="fa-solid fa-arrow-up-right-from-square fa-xs"></i></a>
                                                </div></div>
                                            <div class="row mt-1"><div class="col text-secondary fw-semibold">{link.title}</div></div>
                                            <div class="row mt-2"><div class="col text-secondary">{link.summary}</div></div>
                                            <div class="row mt-2">
                                                <div class="col" style={{display: "flex", flexWrap: "wrap", rowGap: "5px"}}>
                                                    { link.topics.map((topic) => {
                                                        return <><input type="submit" value={topic} className="resultTopicLabel"/>&nbsp;</>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                            })
                        }
                    </>
                }
            </div>
    )
}

CodeSections.displayName = "CodeSections";
export default CodeSections;